module.exports = __webpack_public_path__ + "img/826-1.76ba53c8.png";